<div data-testid="zone-tile">
    <div class="zone__top border-zone cursor-pointer" (click)="setTemplate()">
        <floating-subtitle class="zone__name zone__name--tile font-21"
                           [text]="labels.title">
        </floating-subtitle>
        <div class="zone__set-values bg-gradient bg-gradient--zone color-mobile-white">
            <div class="zone__set-value" data-testid="set-current-temp-mobile">
                {{ tile.params.setCurrentTemp | format:7 }}
            </div>
            <div class="zone__set-value" data-testid="set-temp-dhw-mobile">
                {{ tile.params.setTempDHW | format:7 }}
            </div>
        </div>
    </div>

    <div class="zone__status cursor-pointer" (click)="setTemplate()">
        <div class="zone__status-background gradient-zone" data-testid="animation"
             [class.zone__status--animated]="isStatusAnimated">
        </div>
    </div>

    <div class="zone__content cursor-pointer" (click)="setTemplate()">
        <div class="zone__content-icon">
            <icon [iconName]="'opentherm'"
                  data-testid="tile-icon-opentherm"
                  [iconSize]="views.isMobileView() ? 40 : 50"
                  [className]="'zone__icon zone__icon--white zone__icon--tile fill-icon-grey'">
            </icon>
            <icon [iconName]="'opentherm'"
                  data-testid="tile-icon-opentherm-mobile"
                  [iconSize]="views.isMobileView() ? 40 : 50"
                  [className]="'zone__icon zone__icon--dark fill-black fill-icon-grey'">
            </icon>
        </div>
        <div class="zone__temperatures">
            <div class="zone__temperature-wrapper font-32">
                <div class="zone__current-temp-label">{{ labels.currentTemp }}</div>
                <div class="zone__current-temp zone__current-temp--opentherm-medium"
                    data-testid="current-temp">
                    {{ tile.params.currentTemp | format:7 }}
                </div>
                <div class="zone__current-temp zone__current-temp--small"
                     data-testid="set-current-temp">
                    {{ tile.params.setCurrentTemp | format:7 }}
                </div>
            </div>
            <div class="zone__temperature-wrapper font-32">
                <div class="zone__current-temp-label">{{ labels.currentTempDHW }}</div>
                <div class="zone__current-temp zone__current-temp--opentherm-medium"
                    data-testid="current-temp-dhw">
                    {{ tile.params.currentTempDHW | format:7 }}
                </div>
                <div class="zone__current-temp zone__current-temp--small"
                    data-testid="set-temp-dhw">
                    {{ tile.params.setTempDHW | format:7 }}
                </div>
            </div>
        </div>
    </div>

    @if (zones.valveDropdown.opentherm) {
        <div class="dropdown-list dropdown-list--grey"
             (click)="zones.showHideDropdownList(0)"
             [ngStyle]="{ bottom: zones.valveDropdown.position.bottom, top: zones.valveDropdown.position.top}">
            @if (tile.params.modulationPercentage >=0 && tile.params.modulationPercentage <= 100) {
                <div class="dropdown-list__item color-basic font-12 font-bold">
                    <p class="dropdown-list__item-name">{{ labels.modulationPercentage }}</p>
                    <div class="dropdown-list__value dropdown-list__value--single">
                        <p class="dropdown-list__value-name">
                            {{ tile.params.modulationPercentage | format:8 }}
                        </p>
                    </div>
                </div>
            }
            @if (tile.params.flags.communication === 0) {
                <div class="dropdown-list__item color-basic font-12 font-bold">
                    <p class="dropdown-list__item-name">{{ labels.communication }}</p>
                    <div class="dropdown-list__value dropdown-list__value--single">
                        <img class="dropdown-list__signal dropdown-list__signal--no-margin"
                             data-testid="parameter-communication-icon"
                             ngSrc="/assets/img/zone_icons/cable_black_48dp.svg"
                             width="19" height="19" alt=""/>
                    </div>
                </div>
            }
            <div class="dropdown-list__item color-basic font-12 font-bold">
                <p class="dropdown-list__item-name">{{ labels.heatingCurve }}</p>
                <div class="dropdown-list__value dropdown-list__value--single">
                    <p class="dropdown-list__value-name">
                        {{ tile.params.flags.heatingCurve | format:28 }}
                    </p>
                </div>
            </div>
            <div class="dropdown-list__item color-basic font-12 font-bold">
                <p class="dropdown-list__item-name">{{ labels.activeHeating }}</p>
                <div class="dropdown-list__value dropdown-list__value--single">
                    <p class="dropdown-list__value-name">
                        {{ tile.params.flags.activeHeating | format:28 }}
                    </p>
                </div>
            </div>
            <div class="dropdown-list__item color-basic font-12 font-bold">
                <p class="dropdown-list__item-name">{{ labels.activeDHW }}</p>
                <div class="dropdown-list__value dropdown-list__value--single">
                    <p class="dropdown-list__value-name">
                        {{ tile.params.flags.activeDHW | format:28 }}
                    </p>
                </div>
            </div>
        </div>
    }

    <div class="zone__footer zone__footer--opentherm bg-style">
        <div class="zone__flags-icons">
            @if (tile.params.flags.activeDHW === 1) {
                <img class="zone__icon zone__icon--white"
                     ngSrc="/assets/img/zone_icons/light/DHW-light.svg"
                     width="40" height="40" alt=""/>
            }
            @if (tile.params.flags.activeHeating === 1) {
                <img class="zone__icon zone__icon--white zone__icon--medium"
                     ngSrc="/assets/img/zone_icons/light/pump.svg"
                     width="24" height="24" alt=""/>
            }
            @if (tile.params.flags.heatingCurve === 1) {
                <img class="zone__icon zone__icon--white"
                     ngSrc="/assets/img/zone_icons/light/heating-curve-light.svg"
                     width="40" height="40" alt=""/>
            }
            @if (tile.params.flags.communication === 0) {
                <img class="zone__icon zone__icon--white  zone__icon--small"
                     data-testid="communication-icon"
                     ngSrc="/assets/img/zone_icons/cable_white_48dp.svg"
                     width="40" height="40" alt=""/>
            }
        </div>
        <div class="zone__icons zone__icons--opentherm">
            <div class="zone__settings bg-input bg-input--primary cursor-pointer"
                 (click)="zones.showHideDropdownList('opentherm')"
                 [class.bg-input--open]="zones.valveDropdown.opentherm">
                <icon [iconName]="'settings'"
                      data-testid="settings-icon"
                      [iconSize]="40"
                      [className]="'fill-icon fill-icon--white'">
                </icon>
            </div>
        </div>
    </div>

    @if (tile.params.alarmCode > 0) {
        <div class="zone__alert bg-dark-shadow zone__alert--without-actuator cursor-pointer"
             (click)="setTemplate()">
            <div class="zone__alert-top"></div>
            <div class="zone__alert-wrapper">
                <p class="zone__alert-name font-18" data-testid="tile-alert">
                    {{ labels.alarmCode + ': ' + tile.params.alarmCode }}
                </p>
                <svg width="50" height="50"
                     class="tile__svg--alarm-animation fill-alert">
                    <text x="25" y="45" font-size="65" font-weight="bold"
                          text-anchor="middle">!
                    </text>
                </svg>
            </div>
        </div>
    }

    @if (tile.params.flags.communication) {
        <div class="zone__alert zone__alert--tile bg-dark-shadow zone__alert--without-actuator cursor-default">
            <div class="zone__alert-top"></div>
            <div class="zone__alert-wrapper">
                <p class="zone__alert-name font-18"  data-testid="tile-alert">
                    {{ labels.communicationAlert }}
                </p>
                <svg width="50" height="50"
                     class="tile__svg--alarm-animation fill-alert">
                    <text x="25" y="45" font-size="65" font-weight="bold"
                          text-anchor="middle">!
                    </text>
                </svg>
            </div>
        </div>
    }
</div>
